module.exports = __webpack_public_path__ + "img/StadiumRegistro.6fc289be.png";